import { footerData } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <span className="text-lg font-heading font-bold text-background-50 mb-4 block">
              52吃瓜网
            </span>
            <p className="text-sm text-primary-200 leading-relaxed">
              {footerData.description}
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4">快速导航</h3>
            <div className="flex flex-col gap-2">
              {footerData.quickLinks.map((link, i) => (
                <a
                  key={i}
                  href={link.href}
                  className="text-sm text-primary-200 hover:text-accent-300 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-primary-200 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-primary-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-primary-300">
              {footerData.copyright}
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-primary-300 hover:text-accent-300 transition-colors whitespace-nowrap cursor-pointer">返回顶部</a>
              <span className="text-xs text-primary-600">|</span>
              <span className="text-xs text-primary-300">内容仅供参考</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}